import "./base.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Models ??= {};

AssessmentBuilder.Models.CompletionPage = class CompletionPage extends AssessmentBuilder.Models.Base {
  defaults() {
    return {
      id: this.constructor.guid(),
      type: "inline", // Allowed values: 'redirect', 'inline'
      title: null,
      text: null,
      minScore: null,
      maxScore: null,
      pageId: null,
    };
  }
};
